import PlanView from './PlanFilter.View';

type PlanFilterProps = {
  onFilterPlan: (selectedPlans: string[]) => void;
};

const PlanFilter = ({ onFilterPlan }: PlanFilterProps) => <PlanView onFilterPlan={onFilterPlan} />;

export default PlanFilter;
